export const DEFAULT_LOCALE = 'en-US';
export const PublicNoticeFormStrings = 'PublicNoticeForm';